// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2ozzt","rootSuccess":"CompleteLink_rootSuccess__23Tc7","rootFailure":"CompleteLink_rootFailure__2lOsd","isDisabled":"CompleteLink_isDisabled__2P4ow"};